var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.BaseCard,{staticClass:"offer-card-main offer-card-metrics",attrs:{"title":"Показатели"}},[_c(_setup.OfferMetricsTable,{attrs:{"offer":_setup.props.offer}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }